module.exports = __webpack_public_path__ + "static/sunset-park-cover-image-2926bf2d2bdc18f9c08085ff8f20c43f.jpg";